module.exports = __webpack_public_path__ + "static/media/green-text-radar.89d643e1.png";